// ── UI Text Constants ─────────────────────────────────────
export const TEXT = {
  BUSINESS: {
    NAME: 'Pulsedge',
    DOMAIN: 'Pulsedge.XYZ',
    TAGLINE: 'Solana Signal Intelligence',
    SUBTITLE: 'Smart Money Tracking • Rug Detection • Whale Alerts',
  },

  NAV: {
    FEED: 'Live Feed',
    SIGNALS: 'Signals',
    WHALES: 'Whales',
    RUG_CHECK: 'Rug Check',
    PRICING: 'Pricing',
    INFO: 'About',
  },

  HERO: {
    HEADLINE: 'See What Smart Money Sees',
    SUB: 'Real-time Solana intelligence. Rug detection in under 1.5 seconds. Non-custodial. Always.',
    CTA_PRIMARY: 'Connect Wallet',
    CTA_SECONDARY: 'View Live Feed',
  },

  FEED: {
    TITLE: 'Live Signal Feed',
    EMPTY: 'Scanning chain for signals...',
    NEW_SIGNAL: 'New Signal',
    HIGH_CONVICTION: 'High Conviction',
    BOSS_SIGNAL: 'Boss Man Signal',
    WHALE_ENTRY: 'Whale Entry',
    RUG_WARNING: 'Rug Warning',
  },

  RUG: {
    SAFE: 'Safe',
    CAUTION: 'Caution',
    DANGER: 'Danger',
    RUG: 'Rug',
    SCORE_LABEL: 'Rug Score',
    CHECKS: {
      MINT_AUTH: 'Mint Authority',
      FREEZE_AUTH: 'Freeze Authority',
      LP_BURNED: 'LP Burned',
      TOP10: 'Top 10 Holders',
      METADATA: 'Metadata Immutable',
      BUNDLE: 'Bundle Detection',
      DEPLOYER: 'Deployer History',
    },
  },

  WALLET: {
    CONNECT: 'Connect Wallet',
    CONNECTED: 'Connected',
    DISCONNECT: 'Disconnect',
  },

  TIERS: {
    UPGRADE: 'Upgrade',
    CURRENT: 'Current Plan',
    LOCKED: 'Locked — Upgrade to access',
    PER_MONTH: '/mo',
  },

  FOOTER: {
    TERMS: 'Terms',
    PRIVACY: 'Privacy',
    STATUS: 'Status',
    NON_CUSTODIAL: 'Non-Custodial • We Never Touch Your Keys',
  },
};
